import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { baseURL } from '../config';
import AuthContext from '../Context/AuthContext';
import AssemblyForm from '../Components/AssemblyForm';

function AssemblyEdit() {
    const navigate = useNavigate();
    const { assembly_id } = useParams();
    const { token, logout } = useContext(AuthContext);
    const [fetchingAssemblyData, setFetchingAssemblyData] = useState(true);
    const [assemblyData, setAssemblyData] = useState();
    const [savingAssembly, setSavingAssembly] = useState(false);
    const [assemblyTypeOptions, setAssemblyTypeOptions] = useState([]);
    const [reloadKey, setReloadKey] = useState(0);

    useEffect(() => {
        const fetchAssemblyTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/template/getAssemblyTypes`, {
                    headers: { 'ngrok-skip-browser-warning': 'any', 'x-access-token': token },
                });
                setAssemblyTypeOptions(response.data.data);
            } catch (error) {
                if (error.response?.status === 401) logout();
            }
        };
        fetchAssemblyTypes();
    }, [token, logout]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setFetchingAssemblyData(true);
                const response = await axios.get(`${baseURL}/assembly/getAssembly/${assembly_id}`, {
                    headers: { 'ngrok-skip-browser-warning': 'any', 'x-access-token': token },
                });
                setAssemblyData(response.data.data.assemblyData);
            } catch (error) {
                if (error.response?.status === 401) logout();
            } finally {
                setFetchingAssemblyData(false);
            }
        };
        fetchData();
    }, [assembly_id, token, logout, reloadKey]);

    const handleSave = async (payload) => {
        try {
            setSavingAssembly(true);
            const response = await axios.put(`${baseURL}/assembly/modifyAssembly/${assembly_id}`, payload, {
                headers: { 'ngrok-skip-browser-warning': 'any', 'x-access-token': token },
            });
            if (response.status === 200) {
                return assembly_id;
            }
            return null;
        } catch (error) {
            setSavingAssembly(false);
            if (error.response?.status === 401) {
                logout();
            } else if (error.response?.status === 409) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong, assembly not updated');
            }
            return null;
        }
    };

    const handleSaved = () => {
        setSavingAssembly(false);
        toast.success('Assembly updated successfully');
        navigate(`/assembly_detail/${assembly_id}`);
    };

    return (
        <AssemblyForm
            editAssembly={true}
            assembly_id={assembly_id}
            initialData={assemblyData}
            fetchingAssemblyData={fetchingAssemblyData}
            savingAssembly={savingAssembly}
            onSave={handleSave}
            onSaved={handleSaved}
            onReload={() => setReloadKey((prev) => prev + 1)}
            assemblyTypeOptions={assemblyTypeOptions}
        />
    );
}

export default AssemblyEdit;
